export default __webpack_public_path__ + "static/media/send_white_fill.d5e7d746.svg";